module.exports = __webpack_public_path__ + "img/entrance_en.ab6a2689.png";